



















import { Component, Prop, Vue } from 'vue-property-decorator';


@Component({
    components: {
    },
})
export default class PopoverVue extends Vue {

    close(){
        this.$emit('close');
    }

}

